// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function DriverLeadPageBodyCmp(Props) {
  var children = Props.children;
  return React.createElement("div", {
              className: "driver-onboarding-info-wrapper"
            }, children);
}

var make = DriverLeadPageBodyCmp;

export {
  make ,
  
}
/* react Not a pure module */
